export { default } from "./base-editor";
